import { ui } from '@beelday/common'
import { FC } from 'react'
import { UserRole } from 'common/types'
import { assertUnreachable } from 'utils/unreachable'
import { useRoomProfiles } from 'room/common/use-room-profiles'
import { useAssertedWorkflowUser } from 'room/common/use-workflow-user'
import { useSessionMode } from 'session-mode/use-session-mode'
import LobbyEndUser from './lobby-end-user'
import LobbyInPerson from './lobby-in-person'
import LobbyInPersonMobile from './lobby-in-person.mobile'
import LobbyUpperEchelon from './lobby-upper-echelon'
import { useDispatch, useSelector } from 'react-redux'
import { cancelEditProfile, isEditingProfile } from './redux'
import UserProfileEdit from 'user-profile/user-profile-edit'

const Lobby: FC = () => {
	const workflowUser = useAssertedWorkflowUser()
	const editingProfile = useSelector(isEditingProfile)
	const mode = useSessionMode()
	const isDesktop = ui.responsive.useIsDesktop1024()
	const dispatch = useDispatch()
	useRoomProfiles()

	const closeEditProfile = () => dispatch(cancelEditProfile())

	if (editingProfile) {
		return <UserProfileEdit onClose={closeEditProfile} />
	} else if (!mode) {
		// Features not in yet - or a blended training switching chunks. Guessing
		// would flash the online lobby (video rooms) at an in-person room.
		return <ui.FullScreenSpinner />
	} else if (mode === 'IN_PERSON') {
		// One screen for both roles - the trainer's extra control is a menu item
		// inside it, not a different page. Participants below 1024px get the
		// phone frame they had in the room; the trainer runs from a computer.
		return !isDesktop && workflowUser.role === UserRole.END_USER ? (
			<LobbyInPersonMobile />
		) : (
			<LobbyInPerson />
		)
	} else {
		switch (workflowUser.role) {
			case UserRole.END_USER:
				return <LobbyEndUser />
			case UserRole.UPPER_ECHELON:
				return <LobbyUpperEchelon />
			default:
				assertUnreachable('UserRole', workflowUser.role)
		}
	}
}

export default Lobby
